import styled from '@emotion/styled'

export const StyleInputWrapper = styled.div<any>`
  border: 1px solid
    ${(props: any) =>
      props.theme.colors[!!props?.isError ? 'danger' : 'inputBorder']};
  height: 40px;
  border-radius: 4px;
  width: 100%;
`

export const StyleCreateIconWrapper = styled.div``

export const StyleSelectedItems = styled.div`
  display: flex;
  flex-direction: row;
  column-gap: 10px;
  overflow-x: auto;
  width: 100%;

  -ms-overflow-style: none;
  scrollbar-width: none;
  ::-webkit-scrollbar {
    display: none;
  }
`

export const StyleSelectedItem = styled.div<any>`
  display: flex;
  flex-direction: row;
  column-gap: 5px;
  align-items: center;
  background: ${(props: any) => props.theme.colors[props?.bg]};
  border-radius: 4px;
  padding: 4px 5px;
  white-space: nowrap;
`
